import Keyboard from './components/Keyboard';
export default Keyboard;



// WEBPACK FOOTER //
// ./src/lib/index.js